export default (amount: string, currency: string): string => {
  const par2 = Number((Number(amount) / 100).toFixed(2));
  return new Intl.NumberFormat('en-GB', { style: 'currency', currency }).format(par2);
};
